import styled from 'styled-components';

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    padding: 0;
    overflow: hidden;
    height: 100%;
    margin-top: 80px;

    @media (min-width: 768px) {
        align-items: center;
    }

    @media (min-width: 1024px) {
        flex-direction: row;
        margin-top: 120px;
    }
`;

export const EditorialContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    z-index: 5;
    height: 100%;

    @media (min-width: 1024px) {
        min-height: 720px;
    }
`;

export const Headline = styled.p`
    margin: 0;
    font-size: 10px !important;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.1px;
    align-self: flex-start;
    margin-bottom: 24px;
    color: #191A1F;

    @media (min-width: 1024px) {
        margin-bottom: 0px;
        font-size: 14px !important;
        line-height: 22px;
        letter-spacing: 0.14px;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    width: 100%;
`;

export const CategoriesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    justify-content: center;
    position: relative;
    height: 100%;

    @media (min-width: 1024px) {
        flex-direction: row;
        align-items: center;
    }
`;

export const CategoryColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 5;
    height: 100%;

    @media (min-width: 1024px) {
        align-items: flex-start;

        &:first-child {
            margin-left: 0;
        }
        &:last-child {
            margin-right: 0;
        }
    }
`;

export const ImageWrapper = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: block;
        position: absolute;
        width: 80%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        opacity: 0.1;

        img {
            width: 100%;
            height: auto;
            max-width: 400px;
            max-height: 400px;
            object-fit: contain;
        }
    }

    @media (min-width: 1024px) {
        position: static;
        transform: none;
        width: auto;
        opacity: 1;
        z-index: 10;

        img {
            width: 100%;
            max-width: 588px;
            max-height: 588px;
            object-fit: contain;
        }
    }
`;

export const BackgroundBox = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: block;
        position: absolute;
        width: 720px;
        height: 720px;
        background-color: #f0f0ef; // Default background color
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
        background-size: cover;
        background-position: center;
    }
`;
